export const blockIconsSocialThumbUpNew = (
	<span className='material-symbols-outlined'>thumb_up</span>
);
